// extracted by mini-css-extract-plugin
module.exports = {"iconSize":"ShelfDeleteItem_iconSize__x9jCv"};